// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export const API = {
	get: (url) => {
		return fetch(url, {
			headers: {
				"Content-Type": "application/json",
			},
		}).then((response) => {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		});
	},
	post: (url, body = {}, headers = {}) => {
		const _body = Object.assign(
			{
				__RequestVerificationToken: API.getRequestToken()
			},
			body
		);

		const _headers = Object.assign(
			{
				"Content-Type": "application/json"
			},
			headers
		);

		return fetch(url, {
			method: "POST",
			body: JSON.stringify(_body),
			headers: _headers,
		}).then((response) => {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		});
	},
	getRequestToken(
		requestTokenInputSelector = '#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]'
	) {
		const input = document.querySelector(requestTokenInputSelector);

		if (!input || !input.value) {
			log("Error: Missing __RequestVerificationToken. Aborting");
			return false;
		}
		return input.value;
	},
};



// WEBPACK FOOTER //
// ./client/src/core/plugins/lib/fn.js